import React from "react";
import { useTranslation } from "react-i18next";
import { Control, Controller } from "react-hook-form";
import { VbzInputText } from "@smiles/voebiz-ui-kit";

import { StateType } from "../../../hooks/types";

import ControlledDropdown from "../../ControlledDropdown";
import { formatCNPJ } from "../../../utils/documentUtils";

const CompanyForm = ({ control, errors, state }: { control: Control; errors: any; state: StateType }) => {
  const { t } = useTranslation("register_company");

  return (
    <div className="content-wrapper" data-testid="company-form">
      <div className="inputTextContainer withError">
        <Controller
          name="CNPJ"
          control={control}
          render={({ name, onChange, value }) => (
            <VbzInputText
              id={name}
              name={name}
              disabled
              placeholder={t("input.text.cnpj.placeholder")}
              inputMode="text"
              textLabel={t("input.text.cnpj.label")}
              onChange={onChange}
              value={formatCNPJ(value)}
            />
          )}
        />
      </div>
      <div className="inputTextContainer withError">
        <Controller
          name="socialReason"
          control={control}
          render={({ name, onChange, value }) => (
            <VbzInputText
              id={name}
              name={name}
              placeholder={t("input.text.company_name.placeholder")}
              errorMessage={
                state.member.socialReason.length === 0
                  ? "Esse campo é obrigatório"
                  : "A razão social deve conter pelo menos 1 palavra."
              }
              textLabel={t("input.text.company_name.label")}
              forceError={Boolean(errors.socialReason)}
              onChange={onChange}
              value={value}
            />
          )}
        />
      </div>
      <div className="inputTextContainer withError">
        <Controller
          name="fantasyName"
          control={control}
          render={({ name, onChange, value }) => (
            <VbzInputText
              id={name}
              name={name}
              placeholder={t("input.text.fantasy_name.placeholder")}
              textLabel={t("input.text.fantasy_name.label")}
              errorMessage={
                state.member.socialReason.length === 0
                  ? "Esse campo é obrigatório"
                  : "A razão social deve conter pelo menos 1 palavra."
              }
              forceError={Boolean(errors.fantasyName)}
              onChange={onChange}
              value={value}
            />
          )}
        />
      </div>
      <div className="inputTextContainer">
        <ControlledDropdown
          control={control}
          name="numberOfEmployees"
          placeholder={t(`input.dropdown.numberOfEmployees.placeholder`)}
          textLabel={t(`input.dropdown.numberOfEmployees.label`)}
          errorMessage={t(`input.dropdown.numberOfEmployees.error`)}
          actions={state.dropdowns.numberOfEmployees.items.map((item) => ({ name: item.description, id: item.id }))}
          error={Boolean(errors.numberOfEmployees)}
        />
      </div>
      <div className="inputTextContainer">
        <ControlledDropdown
          control={control}
          name="mainActivity"
          placeholder={t(`input.dropdown.mainActivity.placeholder`)}
          textLabel={t(`input.dropdown.mainActivity.label`)}
          errorMessage={t(`input.dropdown.mainActivity.error`)}
          actions={state.dropdowns.mainActivity.items.map((item) => ({ name: item.description, id: item.id }))}
          error={Boolean(errors.mainActivity)}
        />
      </div>
      <div className="inputTextContainer">
        <ControlledDropdown
          control={control}
          name="annualBudgetforTravel"
          placeholder={t(`input.dropdown.annualBudgetforTravel.placeholder`)}
          textLabel={t(`input.dropdown.annualBudgetforTravel.label`)}
          errorMessage={t(`input.dropdown.annualBudgetforTravel.error`)}
          actions={state.dropdowns.annualBudgetforTravel.items.map((item) => ({ name: item.description, id: item.id }))}
          error={Boolean(errors.annualBudgetforTravel)}
        />
      </div>
    </div>
  );
};

export default CompanyForm;
